module.exports = __webpack_public_path__ + "static/media/xegotech-hlogo.aef3f487.png";